'use client';

export {
    createProductImageGallery,
    generate as generateProductImageGallery,
    showCutList as productImageGalleryShowCutList,
    OFFICIAL_PRODUCT_IMAGE_GALLERY_KEY,
    productImageGalleryTypeKey,
    productImageThumbnailTypeKey,
} from './define';

export { ProductImageGallery } from './ProductImageGallery';
